module.exports = __webpack_public_path__ + "img/icon-84.dcaf7fc5.png";